import React, { useCallback, useMemo } from 'react';
import { RouteComponentProps } from 'react-router';
import { Redirect, Route } from 'react-router-dom';
import { CommonRouteProps } from '../common/routes';
import { DEFAULT_LANDING_PAGE } from '../common/v2/constants';
import { useLatestPreferencesContext } from '../common/v2/context/contexts';

export const PrivateRoute = (
  props: CommonRouteProps & { guard?: () => JSX.Element | undefined }
) => {
  console.log2('Private Route start', { props });
  const { component: PathComponent, ...rest } = props;
  const latestPreferences = useLatestPreferencesContext();
  const companyLandingPage =
    latestPreferences.customLandingPage || DEFAULT_LANDING_PAGE;

  // Use useMemo to ensure consistent hook execution
  const guardResult = useMemo(() => {
    return props.guard ? props.guard() : undefined;
  }, [props.guard]);

  // Use useCallback to ensure render function has stable identity
  const renderFn = useCallback(
    (p: RouteComponentProps<{ [x: string]: string | undefined }>) => {
      console.log2('Private route render', { props });
      if (guardResult) {
        return guardResult;
      }
      return PathComponent ? (
        <PathComponent {...p} />
      ) : (
        <Redirect from="/" to={companyLandingPage} />
      );
    },
    [PathComponent, companyLandingPage, guardResult, props]
  );

  console.log2('Private Route end');

  return <Route {...rest} render={renderFn} />;
};
